import addressListTemplate from "/scripts/_partials/address/templates/addressList.html";
function addressListDirective() {
  return {
    restrict: 'A',
    scope: {
      type: '@',
      //change or view
      initAddressFn: '&',
      changeAddressFn: '&',
      saveAddressFn: '&',
      isShowFullAddress: '<?',
      isShowName: '<?'
    },
    controller: 'AddressListCtrl',
    controllerAs: 'addressList',
    bindToController: true,
    replace: true,
    templateUrl: addressListTemplate
  };
}
export { addressListDirective };